import styled from '@emotion/styled';
import { typography } from 'src/theme/typography';
import { brandPagination } from 'src/pages/Dashboard/paginationStyle';

const VersionModalStyle = styled('div')`
    color: var(--sand-700);
    .ant-table-wrapper .ant-table-thead > tr > th {
        ${typography.bodySm}
        font-weight: 700;
        color: var(--white) !important;
        &::before {
            display: none;
        }
    }
    .ant-table-thead .ant-table-cell {
        border-radius: 0px !important;
        white-space: nowrap;
    }
    .ant-table-wrapper .ant-table.ant-table-small .ant-table-thead > tr > th {
        padding: 12px 16px;
    }
    ${brandPagination}
    .ant-table-wrapper .ant-table.ant-table-small .ant-table-tbody > tr > td {
        ${typography.bodySm}
        padding: 12px 16px;
        color: var(--sand-700);
        border-bottom: 1px solid var(--sand-400);
        &.captionColumn {
            ${typography.caption}
        }
    }
    .ant-table-wrapper
        .ant-table.ant-table-small
        .ant-table-tbody
        > tr
        > td.ant-table-row-expand-icon-cell,
    .ant-table-wrapper
        .ant-table.ant-table-small
        .ant-table-thead
        > tr
        > th.ant-table-row-expand-icon-cell {
        padding: 12px 0 12px 8px;
        text-align: left;
    }
    .ant-table-wrapper .ant-table.ant-table-small {
        td.ant-table-row-expand-icon-cell + td,
        th.ant-table-row-expand-icon-cell + th {
            padding-left: 0;
        }
    }
    .expand-icon {
        display: inline-flex;
        padding: 0;
        border: 0;
        background: transparent;
        font-size: 14px;
        color: var(--sand-700);
        cursor: pointer;
    }
    .ant-table-tbody > tr.ant-table-row:hover > td {
        background: var(--sand-300);
        color: var(--blue-400);
    }
    .viewGroupsActions {
        width: 50px;
        display: flex;
        align-items: center;
        justify-content: end;
        gap: 10px;
        padding-right: 5px;
    }
    .actionIcon {
        cursor: pointer;
    }
    .revisionId {
        font-size: 20px;
        font-weight: 700;
        letter-spacing: -0.03em;
        margin-bottom: 20px;
    }
    .white-space {
        white-space: nowrap;
    }

    .ant-table-wrapper
        .ant-table.ant-table-small
        .ant-table-tbody
        > tr.ant-table-expanded-row
        > td {
        padding: 0;
        background: var(--sand-100);
    }
    .item-quote {
        ${typography.caption}
        padding: 6px 16px 6px 43px;
        .name {
            color: var(--sand-500);
        }
    }
`;

export default VersionModalStyle;
